'use client'

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'


export default function Layout({ children }) {
  const { logout, user } = useAuth()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  
  const allowedEmails = ['charles@cgctg.fr', 'geraldine.besse@immo-phoenix.ch']
  const canCreateAccount = user?.email && allowedEmails.includes(user.email)

  const handleLogout = (e) => {
    e.preventDefault()
    logout()
    navigate('/login')
  }

  return (
    <>
      
      <div>
        <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0">
                  <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                  </button>
                </div>
              </TransitionChild>
              {/* Sidebar component, swap this element with another sidebar if you like */}
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
                <div className="flex h-16 shrink-0 items-center">
                    <img
                    alt="Phoenix Immo"
                    src="/logo.png"
                    className="h-12 w-auto"
                  />
                </div>
                <nav className="flex flex-1 flex-col">
                  <ul role="list" className="flex flex-1 flex-col gap-y-7">
                  <li>
                  <div className="text-xs/6 font-semibold text-gray-400">Messages</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    <li key="ajouter">
                      <a
                        href="/messages/list"
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          AJ
                        </span>
                        <span className="truncate">Messages à valider</span>
                      </a>
                    </li>
                    <li key="history">
                      <a
                        href="/messages/history"
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          HI
                        </span>
                        <span className="truncate">Historique</span>
                      </a>
                    </li>
                  </ul>
                </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-gray-400">Autres</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {canCreateAccount && (
                        <li key="add_register">
                          <a
                            href="/register"
                            className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                          >
                            <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                              CC
                            </span>
                            <span className="truncate">Créer un compte</span>
                          </a>
                        </li>
                        )}
                        <li key="logout">
                          <a
                            href="#"
                            onClick={handleLogout}
                            className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                          >
                            <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                              SD
                            </span>
                            <span className="truncate">Se déconnecter</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6">
            <div className="flex h-16 shrink-0 items-center">
              <img
                alt="Phoenix Immo"
                src="/logo.png"
                className="h-8 w-auto"
              />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                
                <li>
                  <div className="text-xs/6 font-semibold text-gray-400">Messages</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    <li key="ajouter">
                      <a
                        href="/messages/list"
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          AJ
                        </span>
                        <span className="truncate">Messages à valider</span>
                      </a>
                    </li>
                    <li key="history">
                      <a
                        href="/messages/history"
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          HI
                        </span>
                        <span className="truncate">Historique</span>
                      </a>
                    </li>
                  </ul>
                </li>
                
                <li>
                  <div className="text-xs/6 font-semibold text-gray-400">Autres</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {canCreateAccount && (
                    <li key="add_register">
                      <a
                        href="/register"
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          CC
                        </span>
                        <span className="truncate">Créer un compte</span>
                      </a>
                    </li>
                    )}
                    <li key="logout">
                      <a
                        href="#"
                        onClick={handleLogout}
                        className="text-gray-700 hover:bg-gray-50 hover:text-indigo-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                      >
                        <span className="border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600 flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium">
                          SD
                        </span>
                        <span className="truncate">Se déconnecter</span>
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>
            </nav>
          </div>
        </div>

        <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-xs sm:px-6 lg:hidden">
          <button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
          <div className="flex-1 text-sm/6 font-semibold text-gray-900">Menu</div>
        </div>

        <main className="py-10 lg:pl-72">
          <div className="px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </>
  )
}
